import { createContext, useEffect, useRef, useState } from 'react';
import { AppStorage } from '../../../../../../Core/Basic/storage-service';
import { usePortalSettings } from '../../../../../../Core/Hooks/usePortalSettings';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useToast } from '../../../../../../Core/Hooks/useToast';
import {
    deleteImageByID,
    getChecksEditByID,
    getImageByID,
    postChecksData,
    PostImage,
    postSignOffChecksData
} from '../../../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
import moment from 'moment';
import { getTitleData, getVehicleById } from '../../../../../../Core/Services/InternalUser/ControllerService/vehicleService';
import { getCompleteScheduleDropdowns } from '../../../../../../Core/Services/InternalUser/ControllerService/scheduleVehicleService';
import { useWindowSize } from '../../../../../../Core/Hooks/useWindowSize';
import { set } from 'lodash';
import { useLoginInfo } from '../../../../../../Core/Hooks/useLoginInfo';

export const EditInapectionContaxt = createContext();

export const EditInspectionProvide = (props) => {
    let checkhaveAccess = AppStorage.getAllowAcces();
    const { displayName } = useLoginInfo();

    const [widths, heights] = useWindowSize();
    const portalSettings = usePortalSettings();
    const history = useHistory();
    const [btnLoader, setBtnLoader] = useState(false);
    const [confirmBtnLoader, setConfirmBtnLoader] = useState(false);
    const localFileInputRef = useRef(null);
    const [state, setState] = useState({
        vehicleDailyChecks: [],
        tyreAxles: [],
        buttonList: [],
        load: true,
        showbtn: true,
        signAvailable: AppStorage.getSignature() === 'absent' ? false : true,
        isSignOff: false,
        isCustomerSignOff: false,
        submitArray: [],
        vehicleNoOfAxles: null,
        hideSignOff: null,
        vehicleInspectionBrakeTestPhoto: '',
        slippageReasons: [],
        vehicleInspectionSlippageReasonID: null,
        signOffsignature: null,
        showSubmit: false,
        fromApi: false,
        selectedImages: [],
        generatePDF: 'N',
        vehicleDailyChecksResult: [],
        inpsectionNotes: [],
        openDefectInspection: false,
        listOptionsVM: [],
        showImageModal: false
    });

    const [PrevID, setPrevID] = useState(null);
    const [isReload, setIsReload] = useState(null);

    const [flags, setFlags] = useState({ generateDocument: false });

    const [isModal, setIsModal] = useState({ actionTaken: false, selectedCheck: null, showConfirm: false });

    const { showToastSuccess, showToastError } = useToast();
    const [imgLoader, setImgLoader] = useState(false);

    const groupChecks = (checksObjList) => {
        let checksList = checksObjList.map((m, i) => {
            let checksObject = checksObjList.filter((p) => {
                return m.inspectionSheetSectionDescription === p.inspectionSheetSectionDescription;
            });
            checksObject.name = m.inspectionSheetSectionDescription;
            return checksObject;
        });

        return Object.values(checksList.reduce((acc, cur) => Object.assign(acc, { [cur.name]: cur }), {}));
    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((state) => ({ ...state, [name]: value }));
    };

    useEffect(() => {
        if (PrevID) {
            setState((st) => ({ ...st, load: true }));
            getCheckDetails(PrevID);
        } else {
            setState((st) => ({ ...st, load: true }));
            getCheckDetails(props.checkID);
        }
    }, [PrevID, props.checkID, isReload]);

    const handleInpectionRow = (id) => {
        setPrevID(id);
    };

    const getCheckDetails = async (id) => {
        if (props.checkID) {
            try {
                let isSignOff = false;
                let isCustomerSignOff = false;
                let res = await getChecksEditByID(id || props.checkID, props.displayCheck);
                if (res.success) {
                    res.data.vehicleDailyChecksResult.map((m, i) => {
                        if (!m.inspectionSheetCheckResultStatusID) {
                            m.inspectionSheetCheckResultStatusID = 1;
                        }
                    });
                    let TempData = [...res.data.vehicleDailyChecksResult];

                    let checksList = TempData.map((m, i) => {
                        let checksObject;
                        if (TempData.length > 0) {
                            checksObject = TempData.filter((p) => {
                                if (m.inspectionSheetSectionDescription === p.inspectionSheetSectionDescription) {
                                    if (p.defectStatusID === 3) {
                                        isCustomerSignOff = true;
                                    } else if (p.defectStatusID === 1) {
                                        isSignOff = true;
                                    }
                                    return m;
                                }
                            });
                        }
                        checksObject.name = m.inspectionSheetSectionDescription;
                        return checksObject;
                    });

                    let vehicleChecksList = Object.values(checksList.reduce((acc, cur) => Object.assign(acc, { [cur.name]: cur }), {}));
                    const axles = [1, 2, 3, 4].map((num) => res.data.tyreAxles.find((x) => x.axleNumber === num) || { axleNumber: num });
                    let listOptionsVM = res?.data?.listOptionsVM || [];

                    setState((st) => {
                        if (res.success) {
                            return {
                                ...st,
                                load: false,
                                vehicleDailyChecks: vehicleChecksList,
                                tyreAxles: axles,
                                buttonList: res.data.vehicleDailyCheckOptions,
                                ChecksObj: res.data.vehicleDailyChecksResult,
                                statusList: res.data.inspectionSheetCheckResultStatus,
                                isSignOff: isSignOff,
                                isCustomerSignOff: isCustomerSignOff,
                                inpsectionNotes: res.data?.notes || [],
                                listOptionsVM: listOptionsVM
                            };
                        }
                    });
                    res.data.vehicleDailyChecks.map((item) => {
                        if (item.vehicleInspectionSignedOffSignature) {
                            setState((st) => ({
                                ...st,
                                showbtn: false
                            }));
                        }
                        setState((st) => ({
                            ...st,
                            isDisabled: item.vehicleInspectionStatusID == 4,
                            vehicleID: item.vehicleID,
                            vehicleRegNumber: item.vehicleRegNumber,
                            vehicleNoOfAxles:
                                item.vehicleNoOfAxles !== undefined && item.vehicleNoOfAxles !== null ? item.vehicleNoOfAxles : st.vehicleNoOfAxles,
                            date: moment(item.vehicleInspectionDateInspected).format('YYYY-MM-DD'),
                            makeID: item.vehicleMake,
                            modelID: item.vehicleModel,
                            imgtechniciansign: item.vehicleInspectionInspectorSignature,
                            vehicleInspectionScheduleID: item.vehicleInspectionScheduleID,
                            vehicleInspectionStatusID: item.vehicleInspectionStatusID,
                            vehicleInspectionDateInspected: moment(item.vehicleInspectionDateInspected).format('YYYY-MM-DD hh:mm'),
                            vehicleInspectionResult: item.vehicleInspectionResult,
                            vehicleDailyCheckMileage: item.vehicleInspectionMileage,
                            vehicleInspectionSlippageReasonID: item.vehicleInspectionSlippageReasonID,
                            vehicleDailyCheckCheckerName: item.vehicleInspectionInspectorName,
                            vehicleInspectionInspectionComment: item.vehicleInspectionInspectionComment,
                            vehicleInspectionSignedOffName: item.vehicleInspectionSignedOffName,
                            vehicleInspectionSignedOffSignature: item.vehicleInspectionSignedOffSignature,
                            signOffsignature: item.vehicleInspectionSignedOffSignature,
                            hideSignOff: item.vehicleInspectionSignedOffSignature,
                            vehicleInspectionSignedOffDate: item.vehicleInspectionSignedOffDate,
                            vehicleInspectionSignedOffIPAddress: item.vehicleInspectionSignedOffIPAddress,
                            vehicleInspectionID: item.vehicleInspectionID,
                            vehicleInspectionSignedOffComment: item.vehicleInspectionSignedOffComment,

                            vehicleInspectionBrakeTestTypeID: item.vehicleInspectionBrakeTestTypeID, // 2,
                            vehicleInspectionBrakeTestNumber: item.vehicleInspectionBrakeTestNumber, // "12345",
                            vehicleInspectionRoadCondition: item.vehicleInspectionRoadCondition, // "Test Road Conditions",
                            vehicleInspectionServiceBrakePerformance: item.vehicleInspectionServiceBrakePerformance, // 71,
                            vehicleInspectionSecondaryBrakePerformance: item.vehicleInspectionSecondaryBrakePerformance, // 72,
                            vehicleInspectionParkingBrakePerformance: item.vehicleInspectionParkingBrakePerformance, // 73,
                            vehicleInspectionBrakeTestPhoto: item.vehicleInspectionBrakeTestPhoto,
                            generatePDF: item.generatePDF,
                            vehicleDailyChecksResult: [...res.data.vehicleDailyChecksResult],
                            vehicleInspectionInspectorSignOffDate: item.vehicleInspectionInspectorSignOffDate
                            // vehicleInspectionStatusID: item.vehicleInspectionStatusID
                        }));
                    });

                    let flagData = res.data.inspectionSheetTypesVM[0];

                    setFlags((prevFlag) => ({
                        ...prevFlag,
                        displayBrakePerformance: flagData.displayBrakePerformance,
                        displayBrakeTest: flagData.displayBrakeTest,
                        displayMileage: flagData.displayMileage,
                        displayRoadTest: flagData.displayRoadTest,
                        displayTyres: flagData.displayTyres,
                        displayCustomerDeclaration: flagData.displayCustomerDeclaration,
                        startEventLabel: flagData.startEventLabel,
                        endEventLabel: flagData.endEventLabel,
                        displayStartEvent: flagData.displayStartEvent,
                        scheduleEventName: flagData.scheduleEventName,
                        generateDocument: flagData.generateDocument,
                        scheduleEventIs2ndSignOffRequired: flagData.scheduleEventIs2ndSignOffRequired
                    }));
                }
            } catch (error) {
                showToastError('Error fetching inspection Data ');
            }
        }
    };

    useEffect(() => {
        const fetchTitle = async () => {
            if (state.vehicleID) {
                await getTitle();
            }
        };

        fetchTitle();
    }, [state.vehicleID]);

    const closeInspection = () => {
        setPrevID(null);
        setIsReload(new Date());
    };

    const getTitle = async () => {
        let vehicleInformation = await getTitleData(state.vehicleID);
        let DropDownRes = await getCompleteScheduleDropdowns();
        if (vehicleInformation.success) {
            setState((st) => ({
                ...st,
                vehicleInfo: vehicleInformation.data.details[0]?.vehicleDescription,
                vehicleNoOfAxles: vehicleInformation.data.details[0]?.vehicleNoOfAxles,
                slippageReasons: DropDownRes.data?.slippageReasons,
                vehicleNextCalibrationDate: vehicleInformation.data.details[0]?.vehicleNextCalibrationDate,
                vehicleNextLolerTestDate: vehicleInformation.data.details[0]?.vehicleNextLolerTestDate,
                vehicleNextTachoCalibrationDate: vehicleInformation.data.details[0]?.vehicleNextTachoCalibrationDate,
                jobID: vehicleInformation?.data?.details[0]?.jobID
            }));
        }
        let res2 = await getVehicleById(state.vehicleID);
        if (res2.success) {
            const data = res2.data.details[0];
            console.log(data, 'data');
            setState((st) => ({
                ...st,
                regNumber: data.vehicleRegNumber,
                modelID: data.vehicleModel,
                makeID: data.vehicleMake,
                customerID: data.vehicleCustomerID,
                depotID: data.vehicleDepotID
            }));
        }
    };

    const signCanvas = useRef({});
    const clear = () => {
        if (state.vehicleInspectionSignedOffSignature) {
            setState((st) => ({
                ...st,
                vehicleInspectionSignedOffSignature: null,
                signOffsignature: null
            }));
            signCanvas.current.clear();
        } else {
            signCanvas.current.clear();
        }
    };

    const GetTechnicianSign = () => {
        let fields = state.fields;
        setState((st) => {
            const nst = {
                ...st,
                vehicleInspectionSignedOffSignature: signCanvas.current.toDataURL(),
                fields: fields
            };
            return nst;
        });
    };

    const useDefaultSig = () => {
        setState((st) => ({ ...st, img: true, vehicleInspectionSignedOffSignature: AppStorage.getSignature(), signOffsignature: AppStorage.getSignature() }));
    };

    useEffect(() => {
        const handleResize = () => {
            if (
                signCanvas.current &&
                typeof signCanvas.current.fromDataURL === 'function' &&
                state.vehicleInspectionSignedOffSignature &&
                !state.signOffsignature // only restore if not using default
            ) {
                signCanvas.current.fromDataURL(state.vehicleInspectionSignedOffSignature);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [state.vehicleInspectionSignedOffSignature, state.signOffsignature]);

    const validations = () => {
        let formIsValid = true;
        let errors = {};

        // if (!state.vehicleInspectionSignedOffComment) {
        //     errors.vehicleInspectionSignedOffComment = `Signed Off Comment is required`;
        //     formIsValid = false;
        // }
        if (!state.vehicleInspectionSignedOffSignature) {
            errors.vehicleInspectionSignedOffSignature = `Signature is required`;
            formIsValid = false;
        }
        if (flags.displayCustomerDeclaration === 2 || flags.displayCustomerDeclaration === 1) {
            if (!state.vehicleInspectionSignedOffName) {
                errors.vehicleInspectionSignedOffName = `Customer name is required`;
                formIsValid = false;
            }
        }
        setState((st) => ({
            ...st,
            errors: errors
        }));
        return formIsValid;
    };

    const submitSignOffDInsp = async () => {
        if (validations()) {
            let data = {
                vehicleInspectionSignedOffName: state.vehicleInspectionSignedOffName,
                vehicleInspectionSignedOffSignature: state.vehicleInspectionSignedOffSignature,
                vehicleInspectionSignedOffDate: state.vehicleInspectionSignedOffDate,
                vehicleInspectionSignedOffIPAddress: state.vehicleInspectionSignedOffIPAddress,
                vehicleInspectionSignedOffComment: state.vehicleInspectionSignedOffComment,
                vehicleInspectionID: state.vehicleInspectionID
            };
            setConfirmBtnLoader(true);
            let res = await postSignOffChecksData(data);
            if (res.success) {
                showToastSuccess('Inspection Check signed Off successfully');
                if (checkhaveAccess?.CanViewJobs && res?.data?.jobID) {
                    history.push({
                        pathname: `/controller/jobTabScreen/${res.data?.jobID}/${state.vehicleID}`,
                        state: 'jobs',
                        search: 'tab_testing_tabs=1',
                        previousPath: history.location.pathname
                    });
                    props.onClose(true);
                } else {
                    props.onClose(true);
                }
            } else {
                showToastError(res.message);
            }
            setConfirmBtnLoader(false);
        }
    };

    const submitData = async () => {
        if (validations()) {
            let data = {
                vehicleInspectionScheduleID: state.vehicleInspectionScheduleID,
                vehicleInspectionStatusID: 4, //signoff status //state.vehicleInspectionStatusID,
                vehicleInspectionDateInspected: state.vehicleInspectionDateInspected,
                vehicleInspectionResult: state.vehicleInspectionResult,
                vehicleInspectionMileage: state.vehicleDailyCheckMileage,
                vehicleInspectionSlippageReasonID: state.vehicleInspectionSlippageReasonID,
                vehicleInspectionInspectorName: state.vehicleDailyCheckCheckerName,
                vehicleInspectionInspectorSignature: state.techniciansign,
                vehicleInspectionInspectionComment: state.vehicleInspectionInspectionComment,
                // vehicleInspectionSignedOffName: state.vehicleInspectionSignedOffName, //loged user name
                // vehicleInspectionSignedOffSignature: state.vehicleInspectionSignedOffSignature, //current date and time
                vehicleInspectionSignedOffDate: state.vehicleInspectionSignedOffDate,
                // vehicleInspectionSignedOffIPAddress: state.vehicleInspectionSignedOffIPAddress,
                vehicleInspectionID: state.vehicleInspectionID,
                vehicleInspectionBrakeTestTypeID: state.vehicleInspectionBrakeTestTypeID,
                vehicleInspectionBrakeTestNumber: state.vehicleInspectionBrakeTestNumber,
                vehicleInspectionRoadCondition: state.vehicleInspectionRoadCondition,
                vehicleInspectionServiceBrakePerformance: state.vehicleInspectionServiceBrakePerformance,
                vehicleInspectionSecondaryBrakePerformance: state.vehicleInspectionSecondaryBrakePerformance,
                vehicleInspectionParkingBrakePerformance: state.vehicleInspectionParkingBrakePerformance,
                // vehicleInspectionSignedOffComment: state.vehicleInspectionSignedOffComment,
                // inspectionSheetCheckResultsVM: resultVM,
                // inspectionSheetAxlesVM: state.tyreAxles,
                vehicleInspectionBrakeTestPhoto: state.vehicleInspectionBrakeTestPhoto,
                AutoSaved: false
            };
            setConfirmBtnLoader(true);
            let res = await postChecksData(data);
            if (res.success) {
                showToastSuccess('Inspection Check signed Off successfully');
                if (checkhaveAccess?.CanViewJobs && res?.data?.jobID) {
                    history.push({
                        pathname: `/controller/jobTabScreen/${res.data?.jobID}/${state.vehicleID}`,
                        state: 'jobs',
                        search: 'tab_testing_tabs=1',
                        previousPath: history.location.pathname
                    });
                    props.onClose(true);
                } else {
                    props.onClose(true);
                }
            } else {
                showToastError(res.message);
            }
            setConfirmBtnLoader(false);
        }
    };

    const actionTakenHandle = (check) => {
        setIsModal((st) => ({
            ...st,
            actionTaken: true,
            selectedCheck: check
        }));
    };

    const closeActionTakenhandle = (res) => {
        let checkList = [...state.vehicleDailyChecksResult].filter((k) => k.resultStatus === 'Unreviewed');

        let objIndex = checkList.findIndex((x) => x.inspectionSheetCheckResultID === isModal.selectedCheck.inspectionSheetCheckResultID);
        if (objIndex !== -1) {
            checkList.splice(objIndex, 1);
        }

        setIsModal((st) => ({
            ...st,
            actionTaken: false,
            showConfirm: false
        }));

        console.log(checkList, 'checkList');

        res && getCheckDetails();
        res && checkList.length === 0 && props.onClose(true);
    };

    const closeReturnToEngModal = (res) => {
        setIsModal((st) => ({
            ...st,
            returnToEngModalShow: false
        }));
        // res && getCheckDetails();
        res && props.onClose(true);
    };
    const showReturnToEngModal = (res) => {
        setIsModal((st) => ({
            ...st,
            returnToEngModalShow: true
        }));
    };

    const confirmHandle = () => {
        if (validations()) {
            setBtnLoader(true);
            setIsModal((st) => ({
                ...st,
                showConfirm: true
            }));
            setBtnLoader(false);
        }
    };

    const onImageChange = (imageList = [], addUpdateIndex) => {
        console.log(imageList, 'OnchamgeimageList');

        let changedArray = [...state.ChecksObj];
        let FilterimagesList;
        // let objIndex = state.ChecksObj.findIndex((x) => x.inspectionSheetCheckResultID === state.inspectionCheckResultID);

        // if (objIndex > -1) {
        FilterimagesList = imageList.map((m) => (m.data_url ? m.data_url : m));
        // changedArray[objIndex].images = FilterimagesList;
        // }
        let UploadedPhoto = imageList.filter((k) => k.data_url);
        let uniqueImages = UploadedPhoto.map((k) => k.data_url);

        console.log(FilterimagesList, 'FilterimagesList');

        if (!state.showImageModal) {
            const autoSubmit = async () => {
                let data = {
                    vehicleInspectionsPhotoID: null,
                    vehicleInspectionsPhotoResultID: state.inspectionCheckResultID,
                    vehicleInspectionsPhotoObject: uniqueImages
                };
                let res = await PostImage(data);
                if (res.success) {
                    let objIndex = state.ChecksObj.findIndex((x) => x.inspectionSheetCheckResultID === (state.InspectionId || state.inspectionCheckResultID));
                    if (objIndex > -1) {
                        changedArray[objIndex].basicCount = uniqueImages.length;
                        changedArray[objIndex].startPhotosUploaded = state.InspectionId ? uniqueImages.length : changedArray[objIndex].startPhotosUploaded;
                        changedArray[objIndex].photosUploaded = !state.InspectionId ? uniqueImages.length : changedArray[objIndex].photosUploaded;
                    }
                    showToastSuccess('image Uploaded successfully');
                    const updatedVehicleDailyChecks = groupChecks(changedArray);
                    setState((st) => ({
                        ...st,
                        ChecksObj: changedArray,
                        vehicleDailyChecks: updatedVehicleDailyChecks,
                        selectedImages: FilterimagesList,
                        submitArray: [],
                        showSubmit: true,
                        showImageModal: false
                    }));
                }
            };
            autoSubmit();
        } else {
            setState((st) => ({ ...st, ChecksObj: changedArray, selectedImages: FilterimagesList, submitArray: uniqueImages, showSubmit: true }));
        }
    };

    const sumbitImage = async () => {
        let tempArray = [...state.submitArray];
        let data = {
            vehicleInspectionsPhotoID: null,
            vehicleInspectionsPhotoResultID: state.inspectionCheckResultID,
            vehicleInspectionsPhotoObject: tempArray
        };
        let res = await PostImage(data);
        if (res.success) {
            let changedArray = [...state.ChecksObj];
            let objIndex = state.ChecksObj.findIndex((x) => x.inspectionSheetCheckResultID === (state.InspectionId || state.inspectionCheckResultID));
            if (objIndex > -1) {
                changedArray[objIndex].basicCount = state.selectedImages?.length || 0;
                changedArray[objIndex].startPhotosUploaded = state.InspectionId ? state.selectedImages?.length : changedArray[objIndex].startPhotosUploaded;
                changedArray[objIndex].photosUploaded = !state.InspectionId ? state.selectedImages?.length : changedArray[objIndex].photosUploaded;
            }

            showToastSuccess('image Uploaded successfully');
            const updatedVehicleDailyChecks = groupChecks(changedArray);
            setState((st) => ({
                ...st,
                showImageModal: false,
                ChecksObj: changedArray,
                vehicleDailyChecks: updatedVehicleDailyChecks,
                submitArray: [],
                showSubmit: true
            }));
        }
    };

    const imageHandler = async (inspectionCheckResultID, InspectionId) => {
        try {
            let res = await getImageByID(inspectionCheckResultID);
            let imageList = [...(res?.data?.list || [])];
            if (imageList.length > 0) {
                setState((st) => ({
                    ...st,
                    showImageModal: true,
                    inspectionCheckResultID: inspectionCheckResultID,
                    InspectionId: InspectionId,
                    selectedImages: imageList.map((m) => m.vehicleInspectionsPhotoObject) || [],
                    getImageList: imageList || [],
                    submitArray: [],
                    showSubmit: false,
                    fromApi: true
                }));
            } else {
                setState((st) => ({
                    ...st,
                    showImageModal: false,
                    inspectionCheckResultID: inspectionCheckResultID,
                    InspectionId: InspectionId,
                    selectedImages: [],
                    getImageList: [],
                    submitArray: [],
                    showSubmit: false,
                    fromApi: true
                }));
                setTimeout(() => {
                    if (localFileInputRef.current) {
                        localFileInputRef.current.click();
                    }
                }, 50);
            }
        } catch (error) {
            showToastError('Error fetching images');
        }
    };

    const RemoveImage = async (val, i) => {
        setImgLoader(true);
        const tempList = [...(state.getImageList || [])];
        let changedArray = [...state.ChecksObj];
        let FilterimagesList = [...(state.selectedImages || [])];

        const targetPhoto = tempList[i];
        const photoIdToDelete = targetPhoto?.vehicleInspectionPhotoID || (typeof val === 'object' && val?.vehicleInspectionPhotoID);

        if (photoIdToDelete) {
            let res = await deleteImageByID(photoIdToDelete);
            if (res.success) {
                tempList.splice(i, 1);
                FilterimagesList.splice(i, 1);
                let objIndex = changedArray.findIndex((x) => x.inspectionSheetCheckResultID === (state.InspectionId || state.inspectionCheckResultID));
                if (objIndex > -1) {
                    changedArray[objIndex].startPhotosUploaded = state.InspectionId ? FilterimagesList.length : changedArray[objIndex].startPhotosUploaded;
                    changedArray[objIndex].photosUploaded = !state.InspectionId ? FilterimagesList.length : changedArray[objIndex].photosUploaded;
                    changedArray[objIndex].basicCount = FilterimagesList.length;
                    changedArray[objIndex].images = FilterimagesList;
                }
                const updatedVehicleDailyChecks = groupChecks(changedArray);
                const updatedSubmitArray = FilterimagesList.slice(tempList.length);
                setState((st) => ({
                    ...st,
                    ChecksObj: changedArray,
                    vehicleDailyChecks: updatedVehicleDailyChecks,
                    selectedImages: FilterimagesList,
                    getImageList: tempList,
                    submitArray: updatedSubmitArray,
                    showSubmit: updatedSubmitArray.length > 0
                }));
                showToastSuccess('Image Removed Successfully');
            } else {
                showToastError(res?.message || 'Failed to remove image');
            }
        } else {
            FilterimagesList.splice(i, 1);
            if (tempList[i]) {
                tempList.splice(i, 1);
            }
            let objIndex = changedArray.findIndex((x) => x.inspectionSheetCheckResultID === (state.InspectionId || state.inspectionCheckResultID));
            if (objIndex > -1) {
                changedArray[objIndex].images = FilterimagesList;
                changedArray[objIndex].basicCount = FilterimagesList.length;
                changedArray[objIndex].photosUploaded = FilterimagesList.length;
            }
            const updatedVehicleDailyChecks = groupChecks(changedArray);
            const updatedSubmitArray = FilterimagesList.slice(tempList.length);
            setState((st) => ({
                ...st,
                ChecksObj: changedArray,
                vehicleDailyChecks: updatedVehicleDailyChecks,
                selectedImages: FilterimagesList,
                getImageList: tempList,
                submitArray: updatedSubmitArray,
                showSubmit: updatedSubmitArray.length > 0
            }));
            showToastSuccess('Image Removed Successfully');
        }
        setImgLoader(false);
    };

    return (
        <EditInapectionContaxt.Provider
            value={{
                checkhaveAccess,
                widths,
                portalSettings,
                btnLoader,
                confirmBtnLoader,
                state,
                flags,
                isModal,
                handleInput,
                clear,
                GetTechnicianSign,
                imageHandler,
                onImageChange,
                useDefaultSig,
                submitData,
                actionTakenHandle,
                closeActionTakenhandle,
                closeReturnToEngModal,
                showReturnToEngModal,
                confirmHandle,
                sumbitImage,
                setState,
                signCanvas,
                imgLoader,
                RemoveImage,
                handleInpectionRow,
                closeInspection,
                PrevID,
                localFileInputRef,
                submitSignOffDInsp,
                displayName
            }}
        >
            {props.children}
        </EditInapectionContaxt.Provider>
    );
};
